<template>
  <ipo3-page>
    <template slot="title">{{$t("btns.edit")}}</template>
    <template slot="tools">
      <el-button type="primary" @click="goBack" icon="el-icon-back">{{$t('btns.back')}}</el-button>
    </template>
    <template slot="page">
      <div id="home-edit">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="200px"
          class="demo-ruleForm"
        >
          <el-form-item label="語言" prop="type">
            <el-select v-model="ruleForm.language" style="margin-right: 14px;">
              <el-option v-for="item in languages" :key="item.name" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="類型" prop="type">
            <el-select v-model="ruleForm.type" placeholder="請選擇分類">
              <el-option v-for="(item,index) in types" :key="item" :label="item" :value="index"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="新聞" prop="news_id">
            <el-button v-if="!news" @click="onSelect">選擇新聞</el-button>
            <el-card class="box-card" v-else>
              <div slot="header" class="clearfix">
                <span>{{news.title}}</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="onSelect">重新選擇</el-button>
              </div>
              <div class="brief">{{news.describe}}</div>
            </el-card>
          </el-form-item>

          <el-form-item label="封面圖（於網站顯示，可加入文字）" prop="thumb" v-if="ruleForm.type < 0">
            <ipo3-upload @success="onSuccess" ref="upload"></ipo3-upload>
          </el-form-item>
         
          <el-form-item label="排序" prop="sort">
            <el-input v-model="ruleForm.sort">
              <template slot="append">数字越小往前排</template>
            </el-input>
          </el-form-item>
          <el-form-item label="是否顯示" prop="status">
            <el-switch v-model="ruleForm.status"></el-switch>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>
      <el-drawer
        title="新聞綁定"
        :visible.sync="drawer"
        :direction="direction"
        :with-header="true"
        :close-btn="false"
        :before-close="handleClose"
      >      
    <template slot="title">
            <el-input v-model="title" placeholder="查找"></el-input>
    </template>
        <div class="page_view">    
          <el-table
            ref="tableArr"
            v-loading="isLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            :header-cell-style="getRowClass"
          >
            <template v-for="item in items">
              <el-table-column
                :key="item.name"
                header-align="center"
                align="center"
                :label="item.name"
                :prop="item.id"
              ></el-table-column>
            </template>
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              class="operate"
              width="160"
            >
              <template scope="scope">
                <div>
                  <el-button @click="onHandle(scope.row)" size="mini" type="success">選擇</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10,20,30,40,100]"
            :page-size="paginate"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagecount"
          ></el-pagination>
        </div>
      </el-drawer>
    </template>
  </ipo3-page>
</template>
<script>
const types = ["滾動圖", "固定圖", "編輯推薦"];
export default {
  name: "home-news-edit",
  data() {
    return {
      upload_url: `${this.$config.api_url}admin/upload`,
      languages: [{id: 'tw', name: '中文繁體'}, {id: 'cn', name: '中文简体'}, {id: 'en', name: '英文'}],
      drawer: false,
      direction: "rtl",
      tableData: [],
      title: '',
      currentPage: 1,
      pagecount: 1,
      paginate: 5,
      items: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "title" }
      ],
      types: types,
      news: null,
      edit: false,
      ruleForm: {
        language: 'tw',
        type: 0,
        sort: 0,
        title: "",
        status: true,
        news_id: 0,
        thumb: '',
        id: 0
      }
    };
  },

  created() {
    if (this.$route.params.id !== undefined) {
      this.edit = true;
      this.ruleForm.id = this.$route.params.id;
      this.getData(this.$route.params.id);
    } else {
      this.ruleForm.language = this.$route.query.language;
    }
  },

  watch: {
    title: {
      async handler(newVal) {
        this.currentPage = 1;
        this.getNewsData();
      },
      immediate: true,
    }
  },

  methods: {
    getData(id) {
      var self = this;
      this.$http.get("/admin/HomeNews/detail", { id: id }).then(res => {
        self.ruleForm = res.data;
        self.$refs.upload.setImage({
          url: self.ruleForm.thumb,
          name: "news.jpg"
        });
        self.ruleForm.status = self.ruleForm.status==1?true:false;
        self.ruleForm.type = Number(self.ruleForm.type);
        self.news = res.data.news;
        if(self.news)
        {
          self.ruleForm.news_id = self.news.id;
        }
      });
    },
    onSuccess(image) {
      this.ruleForm.thumb = image.path;
    },
    onSelect() {
      this.getNewsData();
      this.drawer = true;
    },
    getNewsData() {
      let self = this;
      this.$http.get("/admin/news/index", {page: this.currentPage, size: this.paginate, language: this.ruleForm.language, title: this.title}).then(res => {
        let {data,total} = res.data;
        self.pagecount = total;
        self.tableData = res.data.data;
      });
    },
    onHandle(value) {
      this.news = value;
      this.ruleForm.title = value.title;
      this.drawer = false;
    },
    onSubmit() {
      let params = Object.assign({},this.ruleForm);
      params.status = params.status ? 1 : 0;

      if (this.news == null) {
        this.$message.error("請選擇新聞");
        return;
      }
      params.news_id = this.news.id;

      this.$http.post("/admin/HomeNews/edit", params).then(res => {
        console.log("res:", res);
        this.$message.success("編輯成功");
      });
    },
    handleSizeChange(size)
    {
      this.paginate = size;
      this.getNewsData(1,size);
    },

    handleCurrentChange(val)
    {
      this.currentPage = val;
      this.getNewsData();
    },
  }
};
</script>

<style lang="less">
#home-edit {
  width: 800px;
  text-align: left;
}
</style>